import React from "react";

export const ArrowLeft: React.FC<{ fill?: "filled" | "none" }> = ({
  fill = "none"
}) => {
  if (fill === "filled") {
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        fill="currentColor"
        width="100%"
        height="100%"
        viewBox="0 0 256 256"
      >
        <path d="M224 128a8 8 0 0 1-8 8h-96v64a8 8 0 0 1-13.66 5.66l-72-72a8 8 0 0 1 0-11.32l72-72A8 8 0 0 1 120 56v64h96a8 8 0 0 1 8 8" />
      </svg>
    );
  }

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="100%"
      height="100%"
      fill="currentColor"
      viewBox="0 0 256 256"
    >
      <path d="M224 128a8 8 0 0 1-8 8H59.31l58.35 58.34a8 8 0 0 1-11.32 11.32l-72-72a8 8 0 0 1 0-11.32l72-72a8 8 0 0 1 11.32 11.32L59.31 120H216a8 8 0 0 1 8 8" />
    </svg>
  );
};
